import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import qs from '../../../_virtual/index2.js';
import mergeDeepRight from '../../../node_modules/ramda/es/mergeDeepRight.js';
import { useHistory, useLocation } from 'react-router-dom';

var _excluded = ["children"];
var createURL = function createURL(state) {
  return "?".concat(qs.stringify(state));
};
var searchStateToUrl = function searchStateToUrl(location, searchState) {
  return searchState ? "".concat(location.pathname).concat(createURL(searchState)) : "";
};
var urlToSearchState = function urlToSearchState(location) {
  return qs.parse(location.search.slice(1));
};

// Updated to use hooks instead of class component
var InstantSearchRouted = function InstantSearchRouted(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var history = useHistory();
  var location = useLocation();
  var _React$useState = React__default.useState(function () {
      return urlToSearchState(location);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchState = _React$useState2[0],
    setSearchState = _React$useState2[1];
  var onSearchStateChange = React__default.useCallback(function (newSearchState) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      clearAll = _ref2.clearAll;
    if (clearAll) {
      history.push("/");
      setSearchState({});
      return;
    }
    var nextState = mergeDeepRight(searchState, newSearchState);
    setSearchState(nextState);
    var updatedUrl = searchStateToUrl(location, nextState);
    history.push(updatedUrl);
  }, [history, location, searchState]);
  return /*#__PURE__*/React__default.createElement(props.InstantSearch, _extends({
    searchState: searchState,
    onSearchStateChange: onSearchStateChange,
    createURL: createURL
  }, props), children);
};
var index = (function (InstantSearch) {
  return function (props) {
    return /*#__PURE__*/React__default.createElement(InstantSearchRouted, _extends({}, props, {
      InstantSearch: InstantSearch
    }));
  };
});

export { index as default, searchStateToUrl };
